export const PICKER_TYPES = {
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  DOCUMENT: 'DOCUMENT'
};
export const ICON_STYLES = {
  circle_color: 'circle_color',
  circle_black: 'circle_black',
  circle_grey: 'circle_grey',
  original_white: 'original_white',
  original_black: 'original_black',
  square_color: 'square_color',
  square_black: 'square_black',
  square_grey: 'square_grey'
};
export const GROUP = 'group';
export const TRANSACTIONAL_ID = -1;
export const BUILTIN_FROM_ADDRESSES = ['{{owner.email}}'];
export const UNSUPPORTED_PERSONALIZATION_TOKENS = {
  deal: ['hs_all_collaborator_owner_ids']
};